<template>
  <div id="app">
   
    <router-view/>
  </div>
</template>

<script>
	import * as types from './types'
  import '../static/fxView/js/popper.min.js';
  import '../static/fxView/js/bootstrap.min.js';
	//import '../static/fxView/js/jquery.min.js';
  import '../static/fxView/js/custom.js';  
  import { fxViewMixins } from '@/plugins/fxView'
  import i18n from '@/plugins/lang/i18n';
    import { mapActions } from 'vuex'
  export default {
    name: 'App',
	mixins: [fxViewMixins],
    data () { 
      return {
		    languageChangeDetect : '' ,
        response_msg1 : '',
        msg_type1 : ''
      }
    },
    created(){
		
		
    },
    mounted: function () {
      const _that = this
      window.addEventListener("storage", (event) => {
        try{
          localStorage.removeItem('clientCountryJson');
          let countriesJson = localStorage.getItem("clientCountryJson")
          if(countriesJson){
            _that.$store.commit(types.SET_COUNTRIES_FOR_CLIENT,JSON.parse(countriesJson))
          }
        }catch(e){ console.log('country-error----------------->',e); }
      });
      $(document).on('keypress', "input[type='text'],textarea", function (event) {
          var key = event.which || event.keyCode;
          if(parseInt(key) > 128){ 
            
            _that.$toasted.show("Only English language is allowed", { 
              position: "top-right", 
              duration : 3000,
              type : 'info'
            });
            return false; 
          }
      })
    },
  }
</script>

<style>
  @import '../static/fxView/css/bootstrap.min.css';
  @import '../static/fxView/css/apidoc_style.css';
  @import '../static/fxView/css/stx-chart.css';
  @import '../static/fxView/css/style.css';
  @import '../static/fxView/css/responsive.css';
  
</style>


// WEBPACK FOOTER //
// src/App.vue